import PropTypes from 'prop-types'

const Svg = (props) => {
  const { id, modifiers } = props

  // do not render the SVG without an id
  if (!id) return ''

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  return (
    <svg className={`Svg${modifierClasses}`}>
      <use xlinkHref={`#${id}`} />
    </svg>
  )
}

Svg.propTypes = {
  id: PropTypes.string.isRequired,
  modifiers: PropTypes.array
}

export default Svg
